import React from "react";
import { Row, Col, Container } from 'react-bootstrap';
import { SvgIcon } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import TypeOfPolicyIcon from '../../../icons/typeOfPolicy.svg';
import DeathBenefitIcon from '../../../icons/deathBenefit.svg'
import InsuranceCarrierIcon from '../../../icons/insuranceCarrier.svg';
import DateIssuedIcon from '../../../icons/dateIssued.svg';
import PolicyBeneficiariesIcon from '../../../icons/policyBeneficiaries.svg';

import './Marketing.scss';

export default function Marketing() {

  const useStyles = makeStyles(theme => ({
    backgroundMain: {
      backgroundColor: `${theme.palette.primary.main}16`,
    },
    backgroundIcon: {
      backgroundColor: `${theme.palette.primary.main}14`,
    },
  }));

  const classes = useStyles();

  return (
    <Row className={`${classes.backgroundMain} marketing-wrapper`}>
      <Container className="marketing-container d-flex justify-content-center">
        <Col lg={7}>
          <h3 className="title">We can help you review your insurance policy</h3>
          <p className="content">Our licensed insurance specialists are available to meet with you over the phone to discuss your current coverage and to review any possible changes or gaps that may exist. We are prepared to review each aspect of your coverage including:</p>
          <ul>
            <li className="d-flex">
              <div className="icon-container">
                <div className={`${classes.backgroundIcon} icon`}>
                  <SvgIcon component={TypeOfPolicyIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Type of policy</h4>
                <p>Determine if the type of policy you have—whether it's term or permanent—fits your current needs.</p>
              </div>
            </li>
            <li className="d-flex">
              <div className="icon-container">
                <div className={`${classes.backgroundIcon} icon`}>
                  <SvgIcon component={DeathBenefitIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Death benefit</h4>
                <p>Look over the coverage amount you originally purchased. Do you have the right benefit amount for your family’s current needs?</p>
              </div>
            </li>
            <li className="d-flex">
              <div className="icon-container">
                <div className={`${classes.backgroundIcon} icon`}>
                  <SvgIcon component={InsuranceCarrierIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Insurance carrier</h4>
                <p>Review your insurance carrier and keep track of the contact information. Having this information easily available can be helpful for your family.</p>
              </div>
            </li>
            <li className="d-flex">
              <div className="icon-container">
                <div className={`${classes.backgroundIcon} icon`}>
                  <SvgIcon component={DateIssuedIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Date issued</h4>
                <p>If you have term life insurance, set a reminder to review your policy before its end date.</p>
              </div>
            </li>
            <li className="d-flex">
              <div className="icon-container">
                <div className={`${classes.backgroundIcon} icon`}>
                  <SvgIcon component={PolicyBeneficiariesIcon} color='primary' />
                </div>
              </div>
              <div className="content-container">
                <h4>Beneficiaries</h4>
                <p>It's critical to check that your beneficiaries continue to reflect your intentions.</p>
              </div>
            </li>
          </ul>
        </Col>
      </Container>
    </Row>
  );
}


// WEBPACK FOOTER //
// ./src/components/PolicyReview/Marketing/Marketing.js